import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Button as DefaultButton } from '../../styled-components';

const StyledButton = styled(DefaultButton)`
  align-items: center;
  display: flex;
  flex-direction: row;
`;

class Button extends React.PureComponent {
  render() {
    const { img, style, text, onClick } = this.props;
    return (
      <StyledButton style={style} onClick={onClick} minHeight="1rem">
        <img style={{ height: 16, marginRight: 4, width: 16 }} src={img} /> {text}
      </StyledButton>
    );
  }
}

Button.propTypes = {
  img: PropTypes.string.isRequired,
  // eslint-disable-next-line
  style: PropTypes.object,
  text: PropTypes.string.isRequired,
  onClick: PropTypes.func
};

Button.defaultProps = {
  style: {},
  onClick: () => {}
};

export default Button;



// WEBPACK FOOTER //
// ./app/components/PublishingDialog/ButtonWithIcon.js